export default {
      id: "caret-right-usage",
      viewBox: "0 0 5 8",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#caret-right",
      toString: function () {
        return this.url;
      }
    }